import axios from 'axios';
import apiConfig from 'utilities/apiConfig';
export function setNumberOfRecipients(number) {
    return {
        type: 'B2B/SET_NUMBER_OF_RECIPIENTS',
        payload: number,
    };
}
export function setDeliveryDate(date) {
    return {
        type: 'B2B/SET_DELIVERY_DATE',
        payload: date,
    };
}
export function setCompanyName(name) {
    return {
        type: 'B2B/SET_COMPANY_NAME',
        payload: name,
    };
}
export function setOrganizationNumber(number) {
    return {
        type: 'B2B/SET_ORGANIZATION_NUMBER',
        payload: number,
    };
}
export function setContactPersonName(name) {
    return {
        type: 'B2B/SET_CONTACT_PERSON_NAME',
        payload: name,
    };
}
export function setContactPersonEmail(mail) {
    return {
        type: 'B2B/SET_CONTACT_PERSON_EMAIL',
        payload: mail,
    };
}
export function setContactPersonPhone(phoneNumber) {
    return {
        type: 'B2B/SET_CONTACT_PERSON_PHONE',
        payload: phoneNumber,
    };
}
export function setComment(comment) {
    return {
        type: 'B2B/SET_COMMENT',
        payload: comment,
    };
}
export function setSelectedProduct(product) {
    return {
        type: 'B2B/SET_SELECTED_PRODUCT',
        payload: product,
    };
}
export function setOrderType(option) {
    return {
        type: 'B2B/SET_ORDER_TYPE',
        payload: option,
    };
}
export function setBillingEmail(email) {
    return {
        type: 'B2B/SET_BILLING_EMAIL',
        payload: email,
    };
}
export function setGiftcardAmount(amount) {
    return {
        type: 'B2B/SET_GIFTCARD_AMOUNT',
        payload: amount,
    };
}
export function fetchB2BProducts(dispatch, region) {
    dispatch({ type: 'B2B/FETCH_PRODUCTS' });
    axios
        .get(`${process.env.API_URL}/${region}/api/v2/products?b2b=true`, apiConfig)
        .then((response) => {
        dispatch({
            type: 'B2B/FETCH_PRODUCTS_SUCCESS',
            payload: {
                region: region,
                products: response.data.data,
            },
        });
    })
        .catch((err) => {
        if (process.env.CONFIG !== 'production') {
            console.log(err);
        }
        dispatch({ type: 'B2B/FETCH_PRODUCTS_FAILED' });
    });
}
export function fetchBusinessLandingPageContent(dispatch, region) {
    const url = `${process.env.API_URL}/${region}/api/businesslandingpage`;
    axios
        .get(url, apiConfig)
        .then((response) => {
        dispatch({
            type: 'B2B/FETCH_LANDING_PAGE_SUCCESS',
            payload: response.data,
        });
    })
        .catch((error) => console.error(error));
}
export function setRegion(dispatch, region) {
    dispatch({
        type: 'B2B/SET_REGION',
        payload: region,
    });
}
export function postB2BOrderRequest(b2bOrder) {
    return axios.post(process.env.CORE_API + '/b2b/order/inquire', Object.assign({}, b2bOrder));
}
